module.exports = __webpack_public_path__ + "static/morgan-6cef7f7b3740f152451f8c61ce009ca3.jpg";